import type { FunctionComponent } from 'react';
import { Modal } from '@property.com.au/ui-kit';
import type { WebLink as IWebLink } from '../../../app-kit/components/WebLink/types';
import { UpdatePropertyDetailsModalContent } from './UpdatePropertyDetailsModalContent/UpdatePropertyDetailsModalContent';
import { useTheme } from 'styled-components';
import { getCssVariableValue } from '../../../app-kit/helpers/getCssVariableValue';
import { convertHexStringToRGBA } from '../../../app-kit/helpers/convertHexStringToRGBA';

interface UpdatePropertyDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  subtitle: string;
  link: IWebLink;
}

export const UpdatePropertyDetailsModal: FunctionComponent<UpdatePropertyDetailsModalProps> = ({
  opened,
  onClose,
  subtitle,
  link,
}) => {
  const theme = useTheme();
  const colourValue = getCssVariableValue(theme.palette.backgroundOverlayStatic);
  const backgroundColor = convertHexStringToRGBA(colourValue, 0.3);

  return (
    <Modal
      opened={opened}
      onRequestClose={onClose}
      getAppElement={() => '#argonaut-wrapper'}
      reactModalProps={{
        style: {
          overlay: {
            backgroundColor,
          },
        },
      }}
    >
      <UpdatePropertyDetailsModalContent subtitle={subtitle} link={link} onClose={onClose} />
    </Modal>
  );
};
